<template>
	<div class="small-12 meterGauge borderRadius50">
		<div class="small-12 gaugeContainer borderRadius50">
			<div :class="classes" :style="width"></div>
		</div>
	</div>
</template>

<script>
	
	export default {

		/*
		** Set the component name
		*/

		name: 'MeterGauge',

		/*
		**  Set the props
		*/

		props: {

			percentage: {
				type: Number,
				default: 0
			},
			colorClass: {
				type: String,
				default: null
			}
			
		},

		/*
		**  Set the computed props
		*/

		computed: {

			width: function() {

				return 'width: ' + this.percentage + '%';

			},

			classes: function() {

				return 'completionPercentage borderRadius50 ' + this.colorClass;

			}

		}

	}

</script>